import type { NodeDimension } from "@/types.ts";

export const NODE_DIMENSIONS: Record<string, NodeDimension> = {
  inputText: { w: 220, h: 140, title: "INPUT TEXT", sub: "string data" },
  inputImage: { w: 220, h: 140, title: "INPUT IMAGE", sub: "base64 data" },
  customScript: { w: 260, h: 220, title: "CUSTOM SCRIPT", sub: "js execution" },
  httpRequest: { w: 240, h: 200, title: "HTTP REQUEST", sub: "fetch api" },
  jsonPath: { w: 220, h: 100, title: "JSON PATH", sub: "extract data" },
  outputText: { w: 280, h: 280, title: "OUTPUT TEXT", sub: "stream render" },
  outputImage: { w: 280, h: 260, title: "OUTPUT IMAGE", sub: "image render" },
  universalOutput: { w: 320, h: 320, title: "UNIVERSAL OUTPUT", sub: "auto display" },
  macroNode: { w: 260, h: 220, title: "MACRO NODE", sub: "sub-graph logic" },
  macroInEdge: { w: 180, h: 100, title: "MACRO IN (edge)", sub: "edge" },
  macroInParam: { w: 180, h: 100, title: "MACRO IN (param)", sub: "param" },
  macroInSettings: { w: 180, h: 100, title: "MACRO IN (settings)", sub: "app settings" },
  macroOutput: { w: 180, h: 100, title: "MACRO OUT", sub: "pass through" },
  macroConnections: {
    w: 180,
    h: 100,
    title: "MACRO CONNS",
    sub: "active ports",
  },
  folderInput: { w: 220, h: 220, title: "FOLDER INPUT", sub: "load directory" },
  batchIterator: { w: 220, h: 200, title: "BATCH ITERATOR", sub: "loop items" },
  delay: { w: 220, h: 100, title: "DELAY", sub: "pause flow" },
  listAggregator: {
    w: 280,
    h: 240,
    title: "LIST AGGREGATOR",
    sub: "collect items",
  },
  downloadData: { w: 240, h: 210, title: "DOWNLOAD DATA", sub: "multi-format" },
  imageProcess: { w: 280, h: 460, title: "IMAGE PROCESS", sub: "resize/convert" },
  reviewNode: { w: 220, h: 160, title: "REVIEW", sub: "manual approval" },
  converter: { w: 220, h: 160, title: "CONVERTER", sub: "format convert" },
  pollUntil: { w: 260, h: 280, title: "POLL UNTIL", sub: "queue polling" },
  textTemplate: { w: 260, h: 220, title: "TEXT TEMPLATE", sub: "interpolation" },
  switchNode: { w: 220, h: 200, title: "SWITCH", sub: "conditional route" },
  mergeNode: { w: 220, h: 180, title: "MERGE", sub: "combine inputs" },
  stringOps: { w: 240, h: 200, title: "STRING OPS", sub: "text transform" },
  counterNode: { w: 240, h: 240, title: "COUNTER", sub: "increment" },
  commentNode: { w: 260, h: 140, title: "COMMENT", sub: "annotation" },
  chatNode: { w: 340, h: 400, title: "CHAT", sub: "message display" },
  // Transformers.js nodes
  transformersPipeline: {
    w: 300,
    h: 300,
    title: "PIPELINE",
    sub: "transformers.js",
  },
  transformersModelLoader: {
    w: 300,
    h: 300,
    title: "MODEL LOADER",
    sub: "transformers.js",
  },
  transformersTokenizerLoader: {
    w: 280,
    h: 240,
    title: "TOKENIZER",
    sub: "transformers.js",
  },
  transformersProcessorLoader: {
    w: 280,
    h: 240,
    title: "PROCESSOR",
    sub: "transformers.js",
  },
  transformersGenerate: {
    w: 300,
    h: 340,
    title: "GENERATE",
    sub: "transformers.js",
  },
  transformersTokenizerEncode: {
    w: 260,
    h: 160,
    title: "ENCODE",
    sub: "tokenizer",
  },
  transformersTokenizerDecode: {
    w: 260,
    h: 140,
    title: "DECODE",
    sub: "tokenizer",
  },
  transformersProcessor: { w: 280, h: 200, title: "PROCESS", sub: "processor" },
  transformersChatTemplate: {
    w: 280,
    h: 200,
    title: "CHAT TEMPLATE",
    sub: "transformers.js",
  },
  transformersEnvConfig: {
    w: 260,
    h: 220,
    title: "ENV CONFIG",
    sub: "transformers.js",
  },
  transformersGenerationConfig: {
    w: 280,
    h: 340,
    title: "GEN CONFIG",
    sub: "parameters",
  },
  audioInput: { w: 220, h: 240, title: "AUDIO INPUT", sub: "audio data" },
  audioOutput: { w: 280, h: 180, title: "AUDIO OUTPUT", sub: "playback" },
  videoInput: { w: 220, h: 240, title: "VIDEO INPUT", sub: "video data" },
  transformersModelCall: {
    w: 260,
    h: 140,
    title: "MODEL CALL",
    sub: "forward pass",
  },
  transformersPostProcessCall: {
    w: 280,
    h: 200,
    title: "POST-PROCESS",
    sub: "call output",
  },
};
